if (!customElements.get('pdp-carousel')) {
  customElements.define('pdp-carousel', class PDPCarousel extends HTMLElement {
  constructor() {
    super();
    document.addEventListener("DOMContentLoaded", this.slider.bind(this));
  }
 
  slider() {
    "use strict";

    // breakpoint where swiper will be destroyed
    // and switches to a dual-column layout
    //const breakpoint = window.matchMedia("(max-width:989px)");

    // keep track of swiper instances to destroy later
    let swiper;

    // var stylesheet = document.querySelector(
    //   "link[href*='keen-slider.min.css']"
    // );
 

    //autoplay functionality
    const autoplay = function (swiper) {
      let timeout;
      let mouseOver = false;
      function clearNextTimeout() {
        clearTimeout(timeout);
      }
      function nextTimeout() {
        clearTimeout(timeout);
        if (mouseOver) return;
        timeout = setTimeout(() => {
          swiper.next();
        }, 5000);
      }
      swiper.on("created", () => {
        swiper.container.addEventListener("mouseover", () => {
          mouseOver = true;
          clearNextTimeout();
        });
        swiper.container.addEventListener("mouseout", () => {
          mouseOver = false;
          nextTimeout();
        });
        nextTimeout();
      });
      swiper.on("dragStarted", clearNextTimeout);
      swiper.on("animationEnded", nextTimeout);
      swiper.on("updated", nextTimeout);
    };

    //navigation functionality
    const navigation = function (swiper) {
      let wrapper, arrowLeft, dots, arrowRight;

      function markup(remove) {
        wrapperMarkup(remove);
        dotMarkup(remove)
        arrowMarkup(remove);
      }

      function removeElement(elment) {
        elment.parentNode.removeChild(elment);
      }

      function createDiv(className) {
        var div = document.createElement("div");
        var classNames = className.split(" ");
        classNames.forEach((name) => div.classList.add(name));
        return div;
      }

      function arrowMarkup(remove) {
        if (remove) {
          removeElement(arrowLeft);
          removeElement(arrowRight);
          return;
        }
        arrowLeft = createDiv("arrow arrow--left pdp-carousel-arrow");
        arrowLeft.addEventListener("click", () => swiper.prev());
        arrowRight = createDiv("arrow arrow--right pdp-carousel-arrow");
        arrowRight.addEventListener("click", () => swiper.next());

        wrapper.appendChild(arrowLeft);
        wrapper.appendChild(arrowRight);
      }

      function updateClasses() {
        var slide = swiper.track.details.rel;
        slide === 0
          ? arrowLeft.classList.add("arrow--disabled")
          : arrowLeft.classList.remove("arrow--disabled");
        slide === swiper.track.details.slides.length - 1
          ? arrowRight.classList.add("arrow--disabled")
          : arrowRight.classList.remove("arrow--disabled");
        Array.from(dots.children).forEach(function (dot, idx) {
          idx === slide
            ? dot.classList.add("dot--active")
            : dot.classList.remove("dot--active")
        })
      }

      function wrapperMarkup(remove) {
        if (remove) {
          var parent = wrapper.parentNode;
          while (wrapper.firstChild)
            parent.insertBefore(wrapper.firstChild, wrapper);
          removeElement(wrapper);
          return;
        }
        wrapper = createDiv("navigation-wrapper");
        swiper.container.parentNode.appendChild(wrapper);
        wrapper.appendChild(swiper.container);
      }


      function dotMarkup(remove) {
        if (remove) {
          removeElement(dots)
          return
        }
        dots = createDiv("dots")
        swiper.track.details.slides.forEach((_e, idx) => {
          var dot = createDiv("dot")
          dot.addEventListener("click", () => swiper.moveToIdx(idx))
          dots.appendChild(dot)
        })
        wrapper.appendChild(dots)
      }  

      function gotToVideo() {
        // const array =  swiper.querySelector('deferred-media').closest('.keen-slider__slide');
        // const findVideo = (element) => { 
        //   element = swiper.querySelector('deferred-media');

        // }
        let index = null;
        swiper.container.querySelectorAll('.keen-slider__slide').forEach((element, i)=> {
          if (element.querySelector('deferred-media')) {
            index = i;
          }
        })
        const link = swiper.container.querySelector('.pdp-go-to-video');
        link.addEventListener('click', ()=> {
          swiper.moveToIdx(index);
        })
      }

      swiper.on("created", () => {
        markup();
        updateClasses();
        gotToVideo();
      });

      swiper.on("optionsChanged", () => {
        markup(true);
        markup();
        updateClasses();

      });
      swiper.on("slideChanged", () => {
        updateClasses();

      });
      swiper.on("destroyed", () => {
        markup(true);
      });
    };

    let slider_instance_name = this.querySelector('[data-slider-instance]').dataset.sliderInstance;
    slider_instance_name = '.'+slider_instance_name;
    const enableSwiper = function () {
      swiper = new KeenSlider(
        slider_instance_name,
        {
          loop: false,
          perView: 1,

        },
        [navigation]
      );
    };

    enableSwiper();
  }
})
}
